import { render, staticRenderFns } from "./cohortChart.vue?vue&type=template&id=e2a0988a"
import script from "./cohortChart.vue?vue&type=script&lang=js"
export * from "./cohortChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports